import React from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { Col, Row, ControlLabel, FormGroup, Radio } from "react-bootstrap";
import { Line as LineChart, HorizontalBar, Bar  } from "react-chartjs-2";
import moment from "moment";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { mapStateToProps } from "../../../RootReducer";
import DashboardService from "../../../services/DashboardService";
import HandleError from "../../../services/HandleError";
import DashboardCard from "./DashboardCard";
import DashboardWrapperCard from "./DashboardWrapperCard";
import InlineError from "../../messages/InlineError";
import LoadingSVG from "../../helpers/LoadingSVG";
import { hasRole } from "../../helpers/Permissions";

class DashboardPage extends React.Component {
	state = {
		isSuperAdmin: hasRole(1),
		isEmployee: hasRole(4),
		isAdmin: hasRole(2),
		start: moment().startOf("week").format("YYYY-MM-DD"),
		end: moment().endOf("week").format("YYYY-MM-DD"), 
		errors: {},
		activeProjects: "",
		activeUsers: "",
		selectedStatuses: "",
		selectedTypes: "",
		userActiveTasks: "",
		userDaysOffTaken: "",
		userTotalLoggedHours: "",
		selectedMonth: moment().month() + 1,
		interval_type: "daily",
		logHoursData: {
			labels: [],
			datasets:[{
				label: "Logged hours",
				backgroundColor: "rgba(54, 162, 235, 1)",
				borderColor: "rgba(54, 162, 150, 1)",
				borderWidth: 2,
			}]
		},
		projectsData: { 
			labels: [], 
			datasets: [ 
				{
					label: "Fixed Costs",
					backgroundColor: "rgba(3, 101, 146, 0.9)",
					data: [] 
				}, 
				{ 
					label: "Employee Costs", 
					backgroundColor: "rgba(54, 162, 235, 0.6)",
					data: [] 
				} 
			] 
		},
		lineChartOptions : {
			scales: { yAxes: [{ ticks: { beginAtZero: true } }] },
			elements: { line: { tension: 0.1 } }
		},
		horizontalBarOptions: { 
			enabled: true, 
			// responsive: true,
			animation: {duration: 0 },
			scales: {  
				xAxes: [{
					stacked: true 
				}], 
				yAxes: [{
					barThickness: 20,
					stacked: true, 
					ticks: {
						beginAtZero:true,
						mirror: true,
					},
				}]
			} 
		}
	}

	componentDidMount = () => {
		const { isSuperAdmin, isEmployee, isAdmin } = this.state;
		if (isSuperAdmin) {
			this.getActiveUsers();
			this.getAllClients();
			this.getActiveProjects();
			this.getLoggedHours();
		} else if (isAdmin || isEmployee) {
			this.getUserActiveTasks();
			this.getUserTakenDaysOff();
			this.getUserTotalHours();
			this.getUserLoggedHours();
		}
	}

	onCheckboxChange = (e) => {
		if(e.target.value) {
			this.setState({
				...this.state, 
				interval_type: e.target.value
			}, () => {
				this.getUserLoggedHours();
			});
		}
	}
	
	onDateChange = (date, name) => {
		if(date) {
			const formatedDate = moment(date).format("YYYY-MM-DD");
			this.setState({
				...this.state,
				[name]: formatedDate
			}, () => {
				this.getLoggedHours();
			});
		}
	}

	getLoggedHours = () => {
		const { start, end } = this.state;
		const errors = this.validateDate(start, end);
		this.setState({ errors });
		if(Object.keys(errors).length === 0) {
			this.setState({isLoadingLoggedHours: true});
			new DashboardService(this,"/log-graph-points").index(0,`start=${start}&end=${end}`).then((res) => {
				this.setState({...this.state,
					isLoadingLoggedHours: false,
					logHoursData: {
						...this.state.logHoursData,
						labels: res.data.day || [],
						datasets: [{
							...this.state.logHoursData.datasets[0],
							data: res.data.time || [],
						}]		
					}
				});
			}).catch((err) => {
				this.setState({isLoadingLoggedHours:false});
				HandleError(err, this);
			});
		}
	}

	getActiveUsers = () => {
		this.setState({isLoadingUsers: true});
		new DashboardService(this,"/get-nr-of-active-users").index(0).then((res) => {
			this.setState({...this.state, 
				isLoadingUsers: false,
				activeUsers: res.data.nr || ""
			});
		}).catch((err) => {
			this.setState({isLoadingUsers: false,});
			HandleError(err, this);
		});
	}

	getAllClients = () => {
		this.setState({isLoadingClients: true});
		new DashboardService(this,"/get-nr-of-active-users").index(0,"roles=3").then((res) => {
			this.setState({...this.state, 
				isLoadingClients: false,
				activeClients: res.data.nr || ""
			});
		}).catch((err) => {
			this.setState({isLoadingClients: false,});
			HandleError(err, this);
		});
	}

	getActiveProjects = () => {
		this.setState({isLoadingProjects:true});
		new DashboardService(this,"/get-nr-of-active-projects").index(0,"statuses=active").then((res) => {
			this.setState({...this.state, 
				isLoadingProjects: false,
				activeProjects: res.data.nr || ""
			});
		}).catch((err) => {
			this.setState({isLoadingProjects:false});
			HandleError(err, this);
		});
	}

	getUserActiveTasks = () => {
		this.setState({isLoadingUserActiveTasks: true});
		new DashboardService(this,"/get-number-of-tasks-assigened").index(0).then((res) => {
			this.setState({...this.state, 
				isLoadingUserActiveTasks: false,
				userActiveTasks: res.data || ""
			});
		}).catch((err) => {
			this.setState({isLoadingUserActiveTasks: false,});
			HandleError(err, this);
		});
	}

	getUserTakenDaysOff = () => {
		this.setState({isLoadingUserDaysOffTaken: true});
		new DashboardService(this,"/get-number-of-days-off").index(0).then((res) => {
			this.setState({...this.state, 
				isLoadingUserDaysOffTaken: false,
				userDaysOffTaken: res.data.days_off_taken || ""
			});
		}).catch((err) => {
			this.setState({isLoadingUserDaysOffTaken: false,});
			HandleError(err, this);
		});
	}

	getUserTotalHours = () => {
		this.setState({isLoadingUserTotalHours: true});
		new DashboardService(this,"/get-number-of-loggedhours").index(0).then((res) => {
			this.setState({...this.state, 
				isLoadingUserTotalHours: false,
				userTotalLoggedHours: res.data.toFixed(2) || ""
			});
		}).catch((err) => {
			this.setState({isLoadingUserTotalHours: false,});
			HandleError(err, this);
		});
	}

	getUserLoggedHours = () => {
		const { interval_type } = this.state;
		this.setState({isLoadingUserLoggedHours: true});
		new DashboardService(this,"/get-user-logged-hours").index(0,`interval_type=${interval_type}`).then((res) => {
			this.setState({
				...this.state,
				isLoadingUserLoggedHours: false,
				logHoursData: {
					...this.state.logHoursData,
					labels: res.data.label || [],
					datasets: [{
						...this.state.logHoursData.datasets[0],
						data: res.data.value || [],
					}]
				}
			});
		}).catch((err) => {
			this.setState({isLoadingUserLoggedHours: false});
			HandleError(err, this);
		});
	}

	getProjectTypes = () => {
		const projectTypes = [
			{value: "standalone", label: "Standalone"},
			{value: "recurring", label: "Recurring"},
			{value: "pay-as-u-go", label: "Pay as you go"},
			{value: "package", label: "Package"},
			{value: "extra-hours", label: "Extra Hours"}
		];
		return projectTypes;
	}

	getProjectStatuses = () => {
		const projectStatuses = [
			{value: "Active", label: "Active"},
			{value: "NotActive ", label: "Inactive"},
			{value: "StandBy", label: "StandBy"},
			{value: "Finished", label: "Finished"}
		];
		return projectStatuses;
	}

	getMonths = () => {
		const months = moment.months().map((item,index) =>({value: index + 1, label: item}));
		return months;
	}

	validateDate = (start, end) => {
		const errors = {};
		if (start && end) {
			const startDate = moment(start);
			const endDate = moment(end);;
			if (endDate.isBefore(startDate)) {
				errors.end = "End date should be after start date.";
			}
		}
		return errors;
	};

	render() {
		const statuses = this.getProjectStatuses();
	  	const types = this.getProjectTypes();
		const months = this.getMonths();
		console.log(this.state.logHoursData);
	  	return (
	  		<div className="crud-page dsh-page">
	  			<div className="container-fluid">
	  				<section className="actions">
	  					<Row>
	  						<Col md={6} sm={6} xs={12}>
	  							<h2 className="page-title">Task 3.2 Dashboard</h2>
	  						</Col>
	  					</Row>   
	  				</section>
	  				<Row>
	  					<Col md={12}>
	  						<div className="card card-top-border connection-card fadeInLoadUp">
	  							{/* Only for superadmin */}
	  							{this.state.isSuperAdmin && 
									<React.Fragment>
										<Row>
											<Col md={4}><DashboardCard class="card-green" icon="people" text="Active users" value={this.state.activeUsers} isLoading={this.state.isLoadingUsers}/></Col>
											<Col md={4}><DashboardCard class="card-violet" icon="storage" text="Active projects" value={this.state.activeProjects} isLoading={this.state.isLoadingProjects} /></Col>									
											<Col md={4}><DashboardCard class="card-orange" icon="transfer_within_a_station" text="Clients" value={this.state.activeClients} isLoading={this.state.isLoadingClients} /></Col>											
											{/* <Col md={3}><DashboardCard class="card-red" icon="favorite" text="Likes" value={321} /></Col>
											<Col md={4}><DashboardCard class="card-red" icon="favorite" text="Likes" value={321} /></Col>
											<Col md={4}><DashboardCard icon="feedback" text="Feedback" value={1540} /></Col>
											<Col md={4}><DashboardCard class="card-gray" icon="stars" text="Rating" value={450} /></Col> */}
										</Row>
										<Row>
											<Col md={12}>
												<DashboardWrapperCard>
													<Row>
														<Col md={3} xs={6}>
															<FormGroup validationState={this.state.errors.start && "error"}>
																<ControlLabel>Start date</ControlLabel>
																<DatePicker
																	selected={moment(this.state.start)}
																	onChange={(e)=>this.onDateChange(e,"start")}
																	dateFormat="DD-MM-YYYY"
																	className="form-control"
																	placeholderText="Choose start date"
																	disabled={this.state.isLoadingLoggedHours}
																/>
																{this.state.errors.start && <InlineError text={this.state.errors.start} />}		
															</FormGroup>
														</Col>
														<Col md={3} xs={6}>
															<FormGroup validationState={this.state.errors.end && "error"}>
																<ControlLabel>End date</ControlLabel>
																<DatePicker
																	selected={moment(this.state.end)}
																	onChange={(e)=>this.onDateChange(e,"end")}
																	dateFormat="DD-MM-YYYY"
																	className="form-control"
																	placeholderText="Choose start date"
																	disabled={this.state.isLoadingLoggedHours}
																	// maxDate={moment()}
																/>
																{this.state.errors.end && <InlineError text={this.state.errors.end} />}	
															</FormGroup>	
														</Col>
													</Row>
													{this.state.isLoadingLoggedHours ? <LoadingSVG /> : 
														<LineChart data={this.state.logHoursData} options={this.state.lineChartOptions} width={100} height={40}  />
													}
												</DashboardWrapperCard>
											</Col>
										</Row>
									</React.Fragment>
	  							}
	  							{/* ====================== */}
								
	  							{/* only for admins and employees */}
	  							{(this.state.isAdmin || this.state.isEmployee) && 
									<React.Fragment>
										<Row>
											<Col md={4}><DashboardCard class="card-green" icon="assignment" text="Active tasks" value={this.state.userActiveTasks} isLoading={this.state.isLoadingUserActiveTasks}/></Col>
											<Col md={4}><DashboardCard class="card-orange" icon="timer_off" text="Days off taken" value={this.state.userDaysOffTaken} isLoading={this.state.isLoadingUserDaysOffTaken} /></Col>
											<Col md={4}><DashboardCard class="card-violet" icon="event_available" text="Total logged hours" value={this.state.userTotalLoggedHours} isLoading={this.state.isLoadingUserTotalHours} /></Col>									
										</Row>
										<Row>
											<Col md={12}>
												<DashboardWrapperCard>
													<Row>
														<Col md={12}>
															<FormGroup>
																<Radio name="interval_type" value="daily" inline  disabled={this.state.isLoadingUserLoggedHours} onChange={(e)=>this.onCheckboxChange(e)} defaultChecked> Last week </Radio>
																<Radio name="interval_type" value="weekly" inline disabled={this.state.isLoadingUserLoggedHours}  onChange={(e)=>this.onCheckboxChange(e)}> Weekly </Radio>
																<Radio name="interval_type" value="monthly" inline  disabled={this.state.isLoadingUserLoggedHours} onChange={(e)=>this.onCheckboxChange(e)}> Monthly </Radio>
															</FormGroup>
														</Col>
													</Row>
													{this.state.isLoadingUserLoggedHours ? <LoadingSVG /> :
														<Bar  data={this.state.logHoursData} options={this.state.lineChartOptions} width={100} height={40} />
													}
												</DashboardWrapperCard>
											</Col>
										</Row>
									</React.Fragment>
	  							}
	  							{/* ====================== */}
								
	  							{/* visible for all roles */}
	  							<Row>	
	  								<Col md={12}>
	  									<DashboardWrapperCard>
	  										<h4>Welcome to Task 3.2</h4>
	  										<ul className="dashboard-list">
	  											<li>Every action is logged on system and can be seen by superadmin.</li>
	  											<li>Personal data of every user is find in profile section.</li>
	  											<li>Personal data can be changed by respectively user and by superadmin.</li>
	  											<li>Password is a personal data that can be edited respectively by users.</li>
	  											<li>In the profile section is possible to change profile image</li>
	  											<li>Personal data, except password are seen by superadmin and can be edited by him/her.</li>
	  											<li>Log hours can be checked in Logs list section.</li>
	  											<li>Everyone can see the logs that they have done.</li>
	  											<li>Logged hours can be edited and deleted by superadmin (all users logs), admin( only logs of users that reported to him.her) and employee (their logs).</li>
	  											<li>Every user can make a request for days off. Superadmin can approve or refuse every user request for days off, admin or employee can approve or refuse only the requests of users that report to him/her.</li>
	  											<li>Bugs report section, there you can report every bug that happens in Task application on your side.</li>
	  											<li>Documents section, there you can find all documents that can be added by superadmins or admins, and employees can only download.</li>
	  											<li>Projects can be created, edited and deleted by superadmins or admins.</li>
	  											<li>Tasks can be created, edited and deleted by superadmins or admins.</li>
	  											<li>Employee can mark his/her task as done.</li>
	  										</ul>
	  									</DashboardWrapperCard>
	  								</Col>						
	  							</Row>
	  						</div> 
	  					</Col>	
	  				</Row>  
	  			</div>
	  		</div>
	  	);
	  }
}

DashboardPage.propTypes = {
};

export default connect(mapStateToProps)(withRouter(DashboardPage));


// WEBPACK FOOTER //
// ./src/components/pages/dashboard/DashboardPage.js